const userApps = {
  userApps: 'Програми адміністратора',
  showing: 'показується',
  userAppsOf: 'програми з',
  noUserAppsFound: 'Програми користувача не знайдено',
};

export default userApps;
